import { render, staticRenderFns } from "./OrderEdit.vue?vue&type=template&id=470e68f4&scoped=true"
import script from "./OrderEdit.vue?vue&type=script&lang=js"
export * from "./OrderEdit.vue?vue&type=script&lang=js"
import style0 from "./OrderEdit.vue?vue&type=style&index=0&id=470e68f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470e68f4",
  null
  
)

export default component.exports